import { Box, Stack } from "@mui/material";
import React from "react";
import { TextView } from "@components";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
function LabelsView({
  wheel,
  onClickLabel,
  mobileContent,
  onClickNext = () => {},
  onClickPrev = () => {},
  disableNext = false,
  disablePrev = false,
}) {
  if (!wheel) {
    return null;
  } else {
    return (
      <>
        <Stack
          sx={{
            // border: "1px solid grey",
            borderRadius: "1vw",
            width: "95vw",
            height: "30vh",
            overflowY: "auto",

            marginLeft: "0.5vw",
            padding: "5px",
            mb: 2,
          }}
        >
          {wheel?.wheel_section?.[0]?.activity_wheel
            ?.sort((a, b) => a.position - b.position)
            ?.map((item, index) => (
              <Stack
                onClick={() => onClickLabel(item, index)}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                sx={{
                  border:
                    item === mobileContent[0]
                      ? "1px solid black"
                      : `0.5px solid ${item?.color}`,
                  borderRadius: "1vw",
                  backgroundColor: item?.inner_color,
                  pl: 1.5,
                  mb: 0.6,
                  py: 1.25,
                  //   height: "20vh",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: item?.color,
                    borderRadius: "50%",
                    height: "20px",
                    width: "20px",
                    mr: 1,
                  }}
                ></Box>
                <TextView
                  style={{
                    fontSize: "14px",
                    color: item === mobileContent[0] ? "#0f0e0f" : "#777777",
                    fontWeight: 500,
                  }}
                >
                  {item?.title}
                </TextView>
              </Stack>
            ))}
        </Stack>
        <Stack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
        >
          <ArrowCircleLeftOutlinedIcon
            style={{ fontSize: "30px", opacity: disablePrev ? 0.5 : 1 }}
            onClick={() => (disablePrev ? null : onClickPrev())}
          />
          <ArrowCircleRightOutlinedIcon
            style={{ fontSize: "30px", opacity: disableNext ? 0.5 : 1 }}
            onClick={() => (disableNext ? null : onClickNext())}
          />
        </Stack>
      </>
    );
  }
}

export default LabelsView;
